export default [
  {
    title: 'Tổng quan',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    roleId: 2
  },
  {
    title: 'Đơn TQ',
    group: 'apps',
    icon: 'ballot',
    name: 'ChinaOrders',
    component: 'ChinaOrders',
    roleId: 1
  },
  // {
  //   title: 'Kiểm hàng',
  //   group: 'apps',
  //   icon: 'checklist',
  //   name: 'CheckOrder',
  //   component: 'CheckOrder',
  //   roleId: 1
  // },
  {
    title: 'Báo cáo',
    group: 'bao-cao',
    icon: 'speed',
    name: 'ReportManagement',
    roleId: 2,
    items: [
      {
        title: 'Báo cáo bán hàng',
        name: 'Reports',
        component: 'Reports',
        roleId: 2,
      },
      {
        title: 'Báo cáo xuất hàng',
        name: 'ReceiptReports',
        component: 'ReceiptReports',
        roleId: 2,
      },
      {
        title: 'Báo cáo trả hàng',
        name: 'ReturnReports',
        component: 'ReturnReports',
        roleId: 2,
      },
      {
        title: 'Báo cáo lợi nhuận',
        name: 'GeneralReports',
        component: 'GeneralReports',
        roleId: 2,
      },
    ]
  },
  {
    title: 'Thanh toán',
    group: 'apps',
    icon: 'wallet',
    name: 'Recharges',
    component: 'Recharges',
    roleId: 2
  },
  {
    title: 'Sản phẩm',
    group: 'quan-ly-san-pham',
    icon: 'style',
    name: 'ProductManagement',
    roleId: 1,
    items: [
      {
        title: 'Sản phẩm bán',
        name: 'Products',
        component: 'Products',
        roleId: 1
      },
      // {
      //   title: 'Sản phẩm xuất', 
      //   name: 'ExportProducts', 
      //   component: 'ExportProducts',
      //   roleId: 1
      // },
      {
        title: 'Danh mục', 
        name: 'Categories', 
        component: 'Categories',
        roleId: 2,
      }
    ]
  },
  {
    title: 'Đơn hàng',
    group: 'quan-ly-don-hang',
    icon: 'shopping_cart',
    name: 'OrderManagement',
    roleId: 1,
    items: [
      {
        title: 'Đơn bán',
        name: 'Orders',
        component: 'Orders',
        roleId: 1
      },
      {
        title: 'Đơn xuất', 
        name: 'ExportOrders', 
        component: 'ExportOrders',
        roleId: 1
      },
      {
        title: 'Trả hàng', 
        name: 'Returns', 
        component: 'Returns',
        roleId: 1
      }
    ]
  },
  {
    title: 'Tài khoản',
    group: 'quan-ly-tai-khoan',
    icon: 'manage_accounts',
    name: 'AccountManagement',
    roleId: 1,
    items: [
      {
        title: 'Nhân viên',
        name: 'Users',
        component: 'Users',
        roleId: 2
      },
      {
        title: 'Khách hàng', 
        name: 'Customers', 
        component: 'Customers',
        roleId: 1
      }
    ]
  },
  {
    title: 'Nhật ký hệ thống',
    group: 'nhat-ky-he-thong',
    icon: 'schedule',
    name: 'SystemLogs',
    roleId: 1
  },
  {
    title: 'Cài đặt',
    group: 'cai-dat',
    icon: 'settings',
    name: 'Configuration',
    roleId: 2
  },
];
